import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=01d70030&scoped=true"
import script from "./NewUserForm.vue?vue&type=script&lang=js"
export * from "./NewUserForm.vue?vue&type=script&lang=js"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=01d70030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d70030",
  null
  
)

export default component.exports